module.exports = __webpack_public_path__ + "static/media/ExpiredCards.6ff45d64.svg";